/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderDtoCreate } from '../../models/order-dto-create';
import { OrderItem } from '../../models/order-item';

export interface OrderControllerCreate$Params {
      body: OrderDtoCreate
}

export function orderControllerCreate(http: HttpClient, rootUrl: string, params: OrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItem;
}>> {
  const rb = new RequestBuilder(rootUrl, orderControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderItem;
      }>;
    })
  );
}

orderControllerCreate.PATH = '/order';
